import styled from "@emotion/styled";

export const CompletedTickContainer = styled.div({
    // position
    position: 'absolute',
    right: 0,
    top: 0,
})